// BL-177 Step 2l: ONE thin band while more than one staff member is in the conversation; gone when back to one.
import React from 'react';
import { othersBandText } from '../../lib/conversationAccess';

export default function ConversationPresenceBand({ count, onOpen }) {
    const text = othersBandText(count);
    if (!text) return null;
    return (
        <button type="button" onClick={onOpen} data-presence-band="true"
            className="block w-full border-b border-[#26365A] bg-[#16223B] px-4 py-0.5 text-left text-xs text-white hover:bg-[#1B2A47]">
            {text}
        </button>
    );
}
